import React from 'react';
import { compose, space, color } from 'styled-system';
import css from '@styled-system/css';
import styled from 'styled-components';

var sizeMap = {
  small: 16,
  medium: 32,
  large: 64
};

function getSvgProps(_ref) {
  var ariaLabel = _ref['aria-label'],
      className = _ref.className,
      size = _ref.size,
      verticalAlign = _ref.verticalAlign,
      svgDataByHeight = _ref.svgDataByHeight;

  var height = sizeMap[size] || size;
  var naturalHeight = closestNaturalHeight(Object.keys(svgDataByHeight), height);
  var naturalWidth = svgDataByHeight[naturalHeight].width;
  var width = height * (naturalWidth / naturalHeight);
  var path = svgDataByHeight[naturalHeight].path;

  return {
    'aria-hidden': ariaLabel ? 'false' : 'true',
    'aria-label': ariaLabel,
    role: 'img',
    className: className,
    viewBox: '0 0 ' + naturalWidth + ' ' + naturalHeight,
    width: width,
    height: height,
    fill: 'currentColor',
    style: {
      display: 'inline-block',
      userSelect: 'none',
      verticalAlign: verticalAlign
    },
    dangerouslySetInnerHTML: { __html: path }
  };
}

function closestNaturalHeight(naturalHeights, height) {
  return naturalHeights.map(function (naturalHeight) {
    return parseInt(naturalHeight, 10);
  }).reduce(function (acc, naturalHeight) {
    return naturalHeight <= height ? naturalHeight : acc;
  }, naturalHeights[0]);
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function LinkIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path fill-rule=\"evenodd\" d=\"M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z\"></path>" }, "24": { "width": 24, "path": "<path d=\"M14.78 3.653a3.936 3.936 0 115.567 5.567l-3.627 3.627a3.936 3.936 0 01-5.88-.353.75.75 0 00-1.18.928 5.436 5.436 0 008.12.486l3.628-3.628a5.436 5.436 0 10-7.688-7.688l-3 3a.75.75 0 001.06 1.061l3-3z\"></path><path d=\"M7.28 11.153a3.936 3.936 0 015.88.353.75.75 0 001.18-.928 5.436 5.436 0 00-8.12-.486L2.592 13.72a5.436 5.436 0 107.688 7.688l3-3a.75.75 0 10-1.06-1.06l-3 3a3.936 3.936 0 01-5.567-5.568l3.627-3.627z\"></path>" } };
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight })));
}

LinkIcon.defaultProps = {
  className: 'octicon',
  size: 16,
  verticalAlign: 'text-bottom'
};

// eslint-disable-next-line import/no-namespace

var COMMON = compose(space, color);

var sx = function sx(props) {
  return css(props.sx);
};

/* THIS FILE IS GENERATED. DO NOT EDIT IT. */

var StyledLinkIcon = styled(LinkIcon)(COMMON, sx);

export default StyledLinkIcon;
